var $2c97811f2dfca292$exports = {};
$2c97811f2dfca292$exports = {
    "endTime": `Pabaigos laikas`,
    "startTime": `Prad\u{17E}ios laikas`,
    "time": `Laikas`
};


export {$2c97811f2dfca292$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
